module.exports = __webpack_public_path__ + "img/logo.1c904df.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo.png
// module id = 531
// module chunks = 2